/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinqrcopylink3Inputs */

const en_checkinqrcopylink3 = /** @type {(inputs: Checkinqrcopylink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

const de_checkinqrcopylink3 = /** @type {(inputs: Checkinqrcopylink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopieren`)
};

/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Checkinqrcopylink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrcopylink3 = /** @type {((inputs?: Checkinqrcopylink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrcopylink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrcopylink3(inputs)
	return de_checkinqrcopylink3(inputs)
});
export { checkinqrcopylink3 as "checkinQrCopyLink" }